export const DEFAULT_TITLE = 'No Title'
export const DEFAULT_OPTION_TITLE_KEY = 'title'
export const DEFAULT_OPTION_CONTENT_KEY = 'content'
export const OPTION_CLICK_EVENT_NAME = 'optionClick'
export const DEFAULT_BORDER_COLOR = 'transparent'
export const CARD_TITLE_TEST_ID = 'information-card-title'
export const CARD_CONTENT_TEST_ID = 'information-card-content'
export const CARD_BORDER_TEST_ID = 'information-card-border'
